import { Fragment, useEffect, useState } from 'react';
import { Button, Col, Row, Modal } from 'react-bootstrap';
import Select from 'react-select';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { useHistory } from 'react-router';
import { CommonLoading } from 'react-loadingg';
import ToolkitProvider, { ColumnToggle, Search } from 'react-bootstrap-table2-toolkit';
import filterFactory, { multiSelectFilter, textFilter } from 'react-bootstrap-table2-filter';
import axios from 'axios';
import Header from './Header';
import moment from 'moment';
import DeleteConfirmationModal from './DeleteConfirmationModal';


const WorkerPerformanceGrading = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [pageNumber, setPageNumber] = useState(0);
    const [editPermit, setEditPermit] = useState(false);
    const [workerGradeList, setWorkerGradeList] = useState([]);
    const [yearList, setAvailableYearList] = useState([]);
    const [quarterList, setAvailableQuarterList] = useState([]);
    const [viewedList, setAvailableViewedList] = useState([{ value: "0", label: "No" }, { value: "1", label: "Yes" }]);
    const [rowCount, setRowCount] = useState();
    const [selected, setSelected] = useState([]);
    const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const { REACT_APP_API_BACKEND_URL } = process.env;
    let yearFilter;
    let quarterFilter;
    let isViewedFilter;



    const { ToggleList } = ColumnToggle;
    const paginationoption = {
        sizePerPage: 50,
    };


    const handlePageChange = ({ selected }) => {
        setPageNumber(selected)
    }


    useEffect(() => {
        if (props.loginList) {
            const loginListFromParent = props.loginList;

            const permit = loginListFromParent.some((item) =>
                (item.permissionName.includes("Admin Role") && item.permissionType.includes("edit"))
                ||
                (item.permissionName.includes("Worker Performance Grading") && item.permissionType.includes("edit"))
            )

            if (permit) {
                setEditPermit(true)
            }
        }
    }, []);

    // !=== Get the entire worker grading list
    useEffect(async () => {

        const loadData = async () => {
            try {
                const gradeList = await fetchWorkerGradeList();
                console.log("Worker grade list: ", gradeList);
                setWorkerGradeList(gradeList);
                setRowCount(gradeList.length);


                const yearItems = [...new Set(gradeList.map(item => item.year))].sort((a, b) => a - b).map(y => ({ label: y, value: y }));
                const quarterItems = [...new Set(gradeList.map(item => item.quarter))].sort((a, b) => a - b).map(q => ({ label: q, value: q }));
                setAvailableYearList(yearItems);
                setAvailableQuarterList(quarterItems);
                setIsLoading(false);
            } catch (err) {
                console.error('Error assigning worker grading data: ', err);
            }
        }
        loadData();
    }, [])

    const fetchWorkerGradeList = async () => {
        try {
            const url = REACT_APP_API_BACKEND_URL + '/api/workerGrade/getWorkerGradeList';
            const response = await axios.get(
                url);
            return response.data.worker_info ?? [];

        } catch (err) {
            console.error('Error fetching worker grading data:', err);
            return [];
        }
    }

    const gradeColumns = [
        {
            dataField: 'id',
            text: 'ID',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' },
            headerAttrs: { width: 150 },
            attrs: { width: 150 },
        },
        {
            dataField: 'full_name',
            text: 'Full Name',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' },
            headerAttrs: { width: 150 },
            attrs: { width: 150 },
        },
        {
            dataField: 'badge_id',
            text: 'Badge ID',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' },
            headerAttrs: { width: 150 },
            attrs: { width: 150 },
        },
        {
            dataField: 'factory',
            text: 'Factory',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' },
            headerAttrs: { width: 150 },
            attrs: { width: 150 },
        },
        {
            dataField: 'department',
            text: 'Department',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' },
            headerAttrs: { width: 150 },
            attrs: { width: 150 },
        },
        {
            dataField: 'grade',
            text: 'Grade',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' },
            headerAttrs: { width: 150 },
            attrs: { width: 150 },
        },
        {
            dataField: 'grade_name',
            text: 'Grade Name',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' },
            headerAttrs: { width: 150 },
            attrs: { width: 150 },
        },
        {
            dataField: 'year',
            text: 'Year',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' },
            headerAttrs: { width: 150 },
            attrs: { width: 150 },
            filter: textFilter(),
            filterRenderer: (filter) => {
                yearFilter = filter;
                return null;
            }
        },
        {
            dataField: 'quarter',
            text: 'Quarter',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' },
            headerAttrs: { width: 150 },
            attrs: { width: 150 },
            filter: textFilter(),
            filterRenderer: (filter) => {
                quarterFilter = filter;
                return null;
            }
        },
        {
            dataField: 'date_created',
            text: 'Date Created',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' },
            formatter: (cell, row) => `${moment(row.date_created).format('YYYY/MM/DD hh:mm:ss')}`,
            headerAttrs: { width: 150 },
            attrs: { width: 150 },
        },
        {
            dataField: 'isViewed',
            text: 'Viewed',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' },
            headerAttrs: { width: 150 },
            attrs: { width: 150 },
            filter: textFilter(),
            filterRenderer: (filter) => {
                isViewedFilter = filter;
                return null;
            }
        }
    ];

    const selectRow = {
        mode: 'checkbox', // Use 'radio' for single selection
        clickToSelect: true,
        selected: selected,
        headerColumnStyle: { width: '20px' },
        onSelect: (row, isSelect) => {
            if (isSelect) {
                setSelected([...selected, row.id]);
            } else {
                setSelected(selected.filter(x => x !== row.id));
            }
        },
        onSelectAll: (isSelect, rows) => {
            if (isSelect) {
                setSelected(workerGradeList.map(g => g.id));
                console.log(selected)
            } else {
                setSelected([]);
            }
        }
    }

    const handleDelete = async () => {
        try {
            if (selected.length === workerGradeList.length) { // Want to delete all
                setShowDeleteConfirmationModal(true);
            } else {
                setIsDeleting(true);
                deleteRecords();
            }


        } catch (error) {
            console.error(error);
            alert('An error occurred while deleting. Please try again or contact IT team.');
        }
    };

    const deleteRecords = async () => {
        setIsDeleting(true);
        const url = REACT_APP_API_BACKEND_URL + '/api/workerGrade/deleteGradeRecord';

        const BATCH_SIZE = 90; // adjust (20–100 recommended)

        let failedItems = [];
        let passedItems = [];
        //!== Used 1 mins 21 sec to delete all
        try {
            for (let i = 0; i < selected.length; i += BATCH_SIZE) {
                const batch = selected.slice(i, i + BATCH_SIZE);

                const requests = batch.map((item) =>
                    axios.post(
                        url,
                        { id: item },
                        { headers: { 'Content-Type': 'application/json' } }
                    )
                );

                const responses = await Promise.allSettled(requests);

                responses.forEach((res, index) => {
                    const id = batch[index];

                    if (res.status === 'fulfilled') {
                        if (res.value.data.statusCode === '1') {
                            passedItems.push(id);
                        } else {
                            failedItems.push(id);
                        }
                    } else {
                        // network / timeout error
                        failedItems.push(id);
                    }
                });
            }

            // ✅ Show result
            if (failedItems.length > 0) {
                alert(
                    `Failed to delete ${failedItems.length} record(s)`
                );
            }

            if (passedItems.length > 0) {
                alert(
                    `Successfully deleted ${passedItems.length} record(s)`
                );
            }

        } catch (e) {
            console.error(e);
            alert("Unexpected error occurred. Please contact IT.");
        } finally {
            setIsDeleting(false);
            setShowDeleteConfirmationModal(false);
            window.location.reload();
        }
    };

    const handleChangeYear = (selectedYear) => {
        if (selectedYear) {
            yearFilter(selectedYear.value);
        } else {
            yearFilter("");
        }
    }

    const handleChangeQuarter = (selectedQuarter) => {
        if (selectedQuarter) {
            quarterFilter(selectedQuarter.value);
        } else {
            quarterFilter("");
        }
    }

    const handleChangeIsViewed = (selectedIsViewed) => {
        if (selectedIsViewed) {
            isViewedFilter(selectedIsViewed.value);
        } else {
            isViewedFilter("");
        }
    }

    const defaultSorted = [{
        dataField: 'id', // grievanceStatusName
        order: 'years'
    }];

    const { SearchBar, ClearSearchButton } = Search;
    const history = useHistory();
    const insertNewBtn = () => {
        history.push({ pathname: '/reports/insertWorkerPerformanceGrade', state: { workerGradeList: workerGradeList } })
    }

    const ExportCSVButton = (props) => {
        const handleClick = () => {
            props.onExport();
        };

        return (
            <Button
                variant='success'
                onClick={handleClick}
                style={{ float: 'right' }}
            >
                Export to CSV
            </Button>
        );
    };

    return (
        <Fragment>

            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div
                        className={`${props.isActive ? 'container is-active' : 'container-fluid'
                            }`}
                    >
                        <Header />
                        <Row>
                            <Col>
                                <div className='btn btn-primary' onClick={insertNewBtn} style={{ marginBottom: '20px' }}>
                                    Insert New
                                </div>
                                {/* <Button variant='primary' disabled style={{ visibility: 'hidden', marginBottom: '20px' }}>
                                    Insert New 2
                                </Button> */}
                            </Col>

                        </Row>
                        <div className='table-wrapper' style={{ marginBottom: '20px' }}>
                            <ToolkitProvider
                                keyField='id'
                                data={workerGradeList}
                                columns={gradeColumns}
                                columnToggle
                                search={{
                                    searchFormatted: true,
                                    afterSearch: (filteredResults) => {
                                        setRowCount(filteredResults.length);
                                    }
                                }}
                                exportCSV={{
                                    fileName: 'Worker Grading List Report.csv',
                                    onlyExportFiltered: true, exportAll: false
                                }}

                            >
                                {
                                    props => (

                                        <div>

                                            <SearchBar {...props.searchProps} />
                                            <ClearSearchButton {...props.searchProps} />
                                            <ExportCSVButton {...props.csvProps} />
                                            <hr />
                                            <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                                                <div><strong>Filter Options</strong></div>
                                                <div style={{ display: 'flex' }}> {/*, justifyContent: 'space-between', alignItems: 'center' */}
                                                    {/* <div style={{ display: 'flex', width: '100%'}}> */}
                                                    <div className='filtergrievancedate'>Year: </div>
                                                    <Select
                                                        className='selectstatus'
                                                        placeholder={'Filter Year'}
                                                        onChange={handleChangeYear}
                                                        // defaultValue={yearList.length > 0 ? yearList[yearList.length - 1] : null} 
                                                        options={yearList}
                                                        isClearable
                                                    />
                                                    <div className='filtergrievancedate'>Quarter: </div>
                                                    <Select
                                                        className='selectstatus'
                                                        placeholder={'Filter Quarter'}
                                                        onChange={handleChangeQuarter}
                                                        options={quarterList}
                                                        isClearable
                                                    />
                                                    <div className='filtergrievancedate'>Viewed: </div>
                                                    <Select
                                                        className='selectstatus'
                                                        placeholder={'Filter Viewed'}
                                                        onChange={handleChangeIsViewed}
                                                        options={viewedList}
                                                        isClearable
                                                    />
                                                    {/* </div> */}
                                                    <div style={{ marginTop: '17px' }}><strong>Total Rows: </strong>{rowCount}</div>
                                                </div>
                                            </div>
                                            <hr />
                                            <div>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <strong>Display Options</strong>
                                                    <Button
                                                        variant="danger"
                                                        onClick={handleDelete}
                                                        disabled={selected.length === 0}
                                                    >
                                                        Delete Selected
                                                    </Button>
                                                </div>
                                                <ToggleList
                                                    contextual='grievance-primary'
                                                    btnClassName='grievance-toggle-column-btn-custom-class'
                                                    {...props.columnToggleProps} // allow user to show / hide table columns
                                                />
                                                <BootstrapTable
                                                    selectRow={selectRow}
                                                    classes='qrevent-table'
                                                    bordered={false}
                                                    {...props.baseProps}
                                                    pagination={paginationFactory(paginationoption)}
                                                    headerWrapperClasses='infohub-header'
                                                    noDataIndication='List is empty.'
                                                    filter={filterFactory()}
                                                    rowEvents={null}
                                                    defaultSorted={defaultSorted}


                                                />
                                                <DeleteConfirmationModal
                                                    show={showDeleteConfirmationModal}
                                                    numOfRows={workerGradeList.length}
                                                    handleClose={() => setShowDeleteConfirmationModal(false)}
                                                    rowData={workerGradeList}
                                                    onDelete={deleteRecords}
                                                />
                                            </div>

                                        </div>
                                    )
                                }
                            </ToolkitProvider>
                        </div>
                    </div>
                </div>
            )}
            {isDeleting && (
                <Modal
                    show={true}
                    centered
                    backdrop='static'
                    keyboard={false}
                >
                    <Modal.Body style={{ textAlign: 'center', padding: '30px', fontSize: '25px' }}>
                        {/* <div style={styles.overlay} > */}
                        <div className='modal-style'>
                            <div className='spinner' />
                            Delete in progress...
                        </div>

                        {/* </div> */}
                    </Modal.Body>
                </Modal>
            )}
        </Fragment>
    );
};

export default WorkerPerformanceGrading;